// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateStorageModal_overlay__ezjwt {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: CreateStorageModal_fadeIn__XcPjN 0.2s ease-in-out;
}

.CreateStorageModal_modal__w7Vq9 {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px;
  width: 420px;
  max-width: 90%;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  animation: CreateStorageModal_scaleIn__PSqLu 0.25s ease;
}

.CreateStorageModal_title__rCn7\\+ {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #222;
  text-align: center;
}

.CreateStorageModal_form__NxBzI {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.CreateStorageModal_inputGroup__D3i3- {
  display: flex;
  flex-direction: column;
}

.CreateStorageModal_inputGroup__D3i3- label {
  font-size: 0.9rem;
  color: #444;
  margin-bottom: 6px;
}

.CreateStorageModal_inputGroup__D3i3- input {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 0.95rem;
  outline: none;
  transition: 0.2s;
}

.CreateStorageModal_inputGroup__D3i3- input:focus {
  border-color: rgba(29, 135, 82, 1);
  box-shadow: 0 0 0 3px rgba(29, 135, 82, 0.3);
}

.CreateStorageModal_buttonGroup__3d7kS {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.CreateStorageModal_createBtn__CII7O {
  text-align: center;
  flex: 1 1;
  background: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  padding: 10px 0;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  margin-right: 10px;
}

.CreateStorageModal_createBtn__CII7O:hover {
  background: rgb(14, 70, 42);
}

.CreateStorageModal_cancelBtn__d8eKG {
  text-align: center;
  flex: 1 1;
  background: #f1f1f1;
  color: #333;
  border: none;
  padding: 10px 0;
  border-radius: 10px;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.2s;
}

.CreateStorageModal_cancelBtn__d8eKG:hover {
  background: #e2e2e2;
}

@keyframes CreateStorageModal_fadeIn__XcPjN {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes CreateStorageModal_scaleIn__PSqLu {
  from {
    transform: scale(0.9);
    opacity: 0.5;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/CreateStorageModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4DAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,uDAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 32px 28px;\n  width: 420px;\n  max-width: 90%;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  animation: scaleIn 0.25s ease;\n}\n\n.title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #222;\n  text-align: center;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.inputGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.inputGroup label {\n  font-size: 0.9rem;\n  color: #444;\n  margin-bottom: 6px;\n}\n\n.inputGroup input {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  outline: none;\n  transition: 0.2s;\n}\n\n.inputGroup input:focus {\n  border-color: rgba(29, 135, 82, 1);\n  box-shadow: 0 0 0 3px rgba(29, 135, 82, 0.3);\n}\n\n.buttonGroup {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.createBtn {\n  text-align: center;\n  flex: 1;\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  padding: 10px 0;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: 0.2s;\n  margin-right: 10px;\n}\n\n.createBtn:hover {\n  background: rgb(14, 70, 42);\n}\n\n.cancelBtn {\n  text-align: center;\n  flex: 1;\n  background: #f1f1f1;\n  color: #333;\n  border: none;\n  padding: 10px 0;\n  border-radius: 10px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.cancelBtn:hover {\n  background: #e2e2e2;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0.5;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CreateStorageModal_overlay__ezjwt`,
	"fadeIn": `CreateStorageModal_fadeIn__XcPjN`,
	"modal": `CreateStorageModal_modal__w7Vq9`,
	"scaleIn": `CreateStorageModal_scaleIn__PSqLu`,
	"title": `CreateStorageModal_title__rCn7+`,
	"form": `CreateStorageModal_form__NxBzI`,
	"inputGroup": `CreateStorageModal_inputGroup__D3i3-`,
	"buttonGroup": `CreateStorageModal_buttonGroup__3d7kS`,
	"createBtn": `CreateStorageModal_createBtn__CII7O`,
	"cancelBtn": `CreateStorageModal_cancelBtn__d8eKG`
};
export default ___CSS_LOADER_EXPORT___;
